import { useMemo, useState } from "react";

export const PREVIEW_PAGE_SIZE = 20;

export function usePaged<T>(items: T[]) {
  const [page, setPage] = useState(1);
  const pageItems = useMemo(
    () =>
      items.slice((page - 1) * PREVIEW_PAGE_SIZE, page * PREVIEW_PAGE_SIZE),
    [items, page]
  );
  const onPageChange = ({ selected }: { selected: number }) =>
    setPage(selected + 1);
  return { page, pageItems, onPageChange };
}
